import BaseView from "@/components/omniSearch/searchViews/BaseView";

const SearchNoResultsView = () => {
  return <BaseView>No results found</BaseView>;
};

export default SearchNoResultsView;
